module.exports = __webpack_public_path__ + "img/trainer-snip4.61de6b56.jpg";